"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var checkNodeVersion_exports = {};
__export(checkNodeVersion_exports, {
  checkNodeVersion: () => checkNodeVersion
});
module.exports = __toCommonJS(checkNodeVersion_exports);
function checkNodeVersion() {
  var [major, minor] = process.version.split(".");
  if (+major < 20) {
    console.error(`One requires Node >= 20.11 (for import.meta.dirname support)`);
    process.exit(1);
  }
  if (+major === 20 && +minor < 12) {
    console.error(`One requires Node >= 20.11 (for import.meta.dirname support)`);
    process.exit(1);
  }
}
//# sourceMappingURL=checkNodeVersion.js.map
